export default __webpack_public_path__ + "static/media/A0004.7d4c25d4.png";